/*
 * Lazy facade over Sentry. Importing this module does NOT pull the Sentry SDK
 * into the bundle — the SDK lives in its own dynamically-imported chunk loaded
 * by init(). Calls made before that chunk finishes loading are buffered and
 * replayed in order once it is ready, so callers never have to await anything.
 */

let sentry = null;
const queue = [];

function defer(fn) {
  if (sentry) fn(sentry);
  else queue.push(fn);
}

/** Load the Sentry SDK chunk, initialise it, and flush any buffered calls. */
export async function init() {
  const mod = await import('../sentry.js');
  mod.initSentry();
  sentry = mod; // exposes setTag / captureException
  for (const fn of queue) fn(sentry);
  queue.length = 0;
}

export function setTag(key, value) {
  defer((S) => S.setTag(key, value));
}

export function captureException(error, hint) {
  defer((S) => S.captureException(error, hint));
}
